import { msg } from '@lingui/macro';
import { md } from 'content/types';

export default {
  title: msg`What’s your household income?`,
  intro: msg`Let us know how much your household earns each year. Don’t worry, we are just using this information to estimate your household tax rate, which helps us provide more accurate guidance.`,
  callout: md(
    msg`The more accurately you share, the better we can personalize this experience for your needs.
${'_lf'}
Providing your household’s income helps us estimate your tax rate and understand tax opportunities across different benefit options.`,
  ),
  whyDoWeNeedThis: md(
    msg`We use your salary and state to estimate your household’s tax rate. We do our best to estimate based on the income you share, but you should really review all of your benefit documents before acting on any personalized guidance.`,
  ),
  tipsBonusesText: msg`If tips, bonuses or any additional income is not included in your paycheck, we’ll ask you about that a little later.`,
  tipsBonusesPartnerText: msg`If tips, bonuses or any additional income is not included in their paycheck, we’ll ask you about that a little later.`,
};
